import React, { useCallback } from "react";
import { Modal, Button } from "react-bootstrap";
import "./CompararImagenesClinicas.css";

function PanelComparacion({ imagen }) {
    if (!imagen?.url) {
        return (
            <div className="comparar-panel">
                <div className="comparar-panel-titulo text-muted">Sin imagen</div>
                <div className="comparar-viewport d-flex align-items-center justify-content-center">
                    <span className="text-muted small">No disponible</span>
                </div>
            </div>
        );
    }

    return (
        <div className="comparar-panel">
            <div className="comparar-panel-titulo text-truncate" title={imagen.nombre}>
                {imagen.nombre}
            </div>
            <div className="comparar-viewport">
                <img src={imagen.url} alt={imagen.nombre} draggable={false} />
            </div>
        </div>
    );
}

function escaparHtml(texto) {
    return String(texto ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;");
}

function CompararImagenesClinicas({ show, onHide, imagenIzquierda, imagenDerecha }) {
    const abrirPestanaCompleta = useCallback(() => {
        if (!imagenIzquierda?.url && !imagenDerecha?.url) return;

        const win = window.open("", "_blank");
        if (!win) {
            alert("No se pudo abrir la pestaña. Permita ventanas emergentes e intente de nuevo.");
            return;
        }

        const izqNombre = escaparHtml(imagenIzquierda?.nombre || "Imagen 1");
        const derNombre = escaparHtml(imagenDerecha?.nombre || "Imagen 2");
        const izqUrl = imagenIzquierda?.url || "";
        const derUrl = imagenDerecha?.url || "";

        win.document.write(`<!DOCTYPE html>
<html lang="es">
<head>
  <meta charset="utf-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>Comparar Imágenes</title>
  <style>
    * { box-sizing: border-box; }
    html, body { margin: 0; height: 100%; background: #1a1d21; color: #f8f9fa; font-family: system-ui, -apple-system, Segoe UI, Roboto, sans-serif; }
    .top {
      display: flex; align-items: center; justify-content: space-between; gap: 1rem; flex-wrap: wrap;
      padding: 0.55rem 1rem; background: #212529; border-bottom: 1px solid #343a40;
      flex-shrink: 0;
    }
    .top h1 { margin: 0; font-size: 1rem; font-weight: 600; }
    .top-actions { display: flex; align-items: center; gap: 0.45rem; flex-wrap: wrap; }
    .zoom-group { display: inline-flex; align-items: center; gap: 0.25rem; }
    .top button {
      border: 1px solid #495057; background: #343a40; color: #f8f9fa;
      border-radius: 0.35rem; padding: 0.35rem 0.7rem; cursor: pointer; font-size: 0.875rem;
      min-width: 2.1rem;
    }
    .top button:hover { background: #495057; }
    .zoom-label {
      min-width: 3.25rem; text-align: center; font-size: 0.85rem; color: #ced4da;
      border: 1px solid #495057; border-radius: 0.35rem; padding: 0.3rem 0.4rem; background: #2b3035;
    }
    .hint { font-size: 0.75rem; color: #adb5bd; margin: 0; }
    .grid {
      display: grid; grid-template-columns: 1fr 1fr; gap: 0.5rem;
      height: calc(100dvh - 3.5rem); padding: 0.5rem; min-height: 0;
    }
    .panel {
      display: flex; flex-direction: column; min-width: 0; min-height: 0;
      background: #000; border: 1px solid #343a40; border-radius: 0.4rem; overflow: hidden;
    }
    .titulo {
      flex-shrink: 0; padding: 0.45rem 0.7rem; font-size: 0.85rem; font-weight: 600;
      background: #2b3035; border-bottom: 1px solid #343a40; white-space: nowrap;
      overflow: hidden; text-overflow: ellipsis;
    }
    .viewport {
      flex: 1 1 auto; min-height: 0; overflow: hidden;
      display: flex; align-items: center; justify-content: center; padding: 0.4rem;
      cursor: grab; touch-action: none; user-select: none;
    }
    .viewport.dragging { cursor: grabbing; }
    .viewport .stage {
      transform-origin: center center;
      line-height: 0;
      will-change: transform;
    }
    .viewport img {
      max-width: min(100%, 100vw);
      max-height: calc(100dvh - 7rem);
      width: auto; height: auto; object-fit: contain;
      pointer-events: none; display: block;
    }
    .empty { color: #adb5bd; font-size: 0.9rem; }
    @media (max-width: 767.98px) {
      .grid { grid-template-columns: 1fr; grid-template-rows: 1fr 1fr; height: calc(100dvh - 5.5rem); }
      .viewport img { max-height: calc(50dvh - 4rem); }
    }
  </style>
</head>
<body>
  <div class="top">
    <div>
      <h1>Comparar imágenes</h1>
      <p class="hint">Rueda del mouse para zoom · Arrastre para mover</p>
    </div>
    <div class="top-actions">
      <div class="zoom-group">
        <button type="button" id="btnZoomOut" title="Alejar">−</button>
        <span class="zoom-label" id="zoomLabel">100%</span>
        <button type="button" id="btnZoomIn" title="Acercar">+</button>
        <button type="button" id="btnZoomReset" title="Restablecer">⟲</button>
      </div>
      <button type="button" onclick="window.close()">Cerrar pestaña</button>
    </div>
  </div>
  <div class="grid">
    <div class="panel">
      <div class="titulo" title="${izqNombre}">${izqNombre}</div>
      <div class="viewport" data-panel="izq">
        ${izqUrl ? `<div class="stage"><img src="${escaparHtml(izqUrl)}" alt="${izqNombre}" /></div>` : '<span class="empty">Sin imagen</span>'}
      </div>
    </div>
    <div class="panel">
      <div class="titulo" title="${derNombre}">${derNombre}</div>
      <div class="viewport" data-panel="der">
        ${derUrl ? `<div class="stage"><img src="${escaparHtml(derUrl)}" alt="${derNombre}" /></div>` : '<span class="empty">Sin imagen</span>'}
      </div>
    </div>
  </div>
  <script>
    (function () {
      var ZOOM_MIN = 0.25, ZOOM_MAX = 5, ZOOM_STEP = 0.2;
      var zoom = 1;
      var pan = { x: 0, y: 0 };
      var stages = Array.prototype.slice.call(document.querySelectorAll('.stage'));
      var label = document.getElementById('zoomLabel');
      var drag = null;

      function aplicar() {
        var t = 'translate(' + pan.x + 'px,' + pan.y + 'px) scale(' + zoom + ')';
        stages.forEach(function (el) { el.style.transform = t; });
        label.textContent = Math.round(zoom * 100) + '%';
      }

      function setZoom(next) {
        zoom = Math.min(ZOOM_MAX, Math.max(ZOOM_MIN, Math.round(next * 100) / 100));
        if (zoom <= 1) { pan.x = 0; pan.y = 0; }
        aplicar();
      }

      document.getElementById('btnZoomIn').onclick = function () { setZoom(zoom + ZOOM_STEP); };
      document.getElementById('btnZoomOut').onclick = function () { setZoom(zoom - ZOOM_STEP); };
      document.getElementById('btnZoomReset').onclick = function () { setZoom(1); };

      document.querySelectorAll('.viewport').forEach(function (vp) {
        vp.addEventListener('wheel', function (e) {
          e.preventDefault();
          setZoom(zoom + (e.deltaY > 0 ? -ZOOM_STEP : ZOOM_STEP));
        }, { passive: false });

        vp.addEventListener('mousedown', function (e) {
          if (e.button !== 0) return;
          drag = { x: e.clientX - pan.x, y: e.clientY - pan.y, el: vp };
          vp.classList.add('dragging');
        });
        vp.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) return;
          drag = { x: e.touches[0].clientX - pan.x, y: e.touches[0].clientY - pan.y, el: vp };
        }, { passive: true });
      });

      window.addEventListener('mousemove', function (e) {
        if (!drag) return;
        pan.x = e.clientX - drag.x;
        pan.y = e.clientY - drag.y;
        aplicar();
      });
      window.addEventListener('mouseup', function () {
        if (drag && drag.el) drag.el.classList.remove('dragging');
        drag = null;
      });
      window.addEventListener('touchmove', function (e) {
        if (!drag || e.touches.length !== 1) return;
        pan.x = e.touches[0].clientX - drag.x;
        pan.y = e.touches[0].clientY - drag.y;
        aplicar();
      }, { passive: true });
      window.addEventListener('touchend', function () { drag = null; });

      aplicar();
    })();
  </script>
</body>
</html>`);
        win.document.close();
    }, [imagenIzquierda, imagenDerecha]);

    return (
        <Modal
            show={show}
            onHide={onHide}
            size="xl"
            centered
            fullscreen
            scrollable={false}
            enforceFocus={false}
            restoreFocus={false}
            className="modal-comparar-clinica-root"
            dialogClassName="modal-comparar-clinica"
            contentClassName="modal-comparar-clinica-content"
        >
            <Modal.Header className="py-2 comparar-modal-header">
                <Modal.Title className="mb-0">
                    <i className="fas fa-columns mr-2 text-info" />
                    Comparar imágenes
                </Modal.Title>
                <div className="comparar-header-actions d-flex align-items-center">
                    <button
                        type="button"
                        className="comparar-btn-header-icon mr-1"
                        title="Abrir en Pestaña Completa"
                        onClick={abrirPestanaCompleta}
                    >
                        <i className="fas fa-external-link-alt" />
                    </button>
                    <button type="button" className="close" aria-label="Cerrar" onClick={onHide}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </Modal.Header>
            <Modal.Body className="p-2">
                <p className="small text-muted mb-2 px-1">
                    Vista lado a lado para comparar evolución o detalles. Use el ícono de pestaña completa si necesita más espacio.
                </p>
                <div className="comparar-grid">
                    <PanelComparacion imagen={imagenIzquierda} />
                    <PanelComparacion imagen={imagenDerecha} />
                </div>
            </Modal.Body>
            <Modal.Footer className="d-flex flex-wrap justify-content-between align-items-center" style={{ gap: "0.5rem" }}>
                <Button variant="outline-info" size="sm" onClick={abrirPestanaCompleta}>
                    <i className="fas fa-external-link-alt mr-1" />
                    Abrir en Pestaña Completa
                </Button>
                <Button variant="secondary" onClick={onHide}>Cerrar</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default CompararImagenesClinicas;
